import { Select, Input } from "antd";
import { CustomTitle, CustomButton } from "../../../components";

const BulkFieldSelector = ({
  editingFieldKey,
  bulkFieldValue,
  setBulkFieldValue,
  couriersList,
  sensorsList,
  productList,
  allTeams,
  locationList,
  ignoreSensorTimes,
  setEditModalOpen,
  handleSave,
}) => {
  const renderSelectOptions = () => {
    switch (editingFieldKey) {
      case "courier":
        return couriersList.map((c) => ({
          label: c.courier_name,
          value: c.courier_name,
        }));
      case "sensor":
        return sensorsList.map((s) => ({
          label: s.sensor_name,
          value: s.sensor_name,
        }));
      case "products":
        return productList.map((p) => ({
          label: p.name,
          value: p.name,
        }));
      case "teams":
        return allTeams.map((t) => ({
          label: t.name,
          value: t.id,
        }));
      case "from_location":
      case "to_location":
        return locationList.map((l) => ({
          label: l.sensor_name || l.location_name || l.name,
          value: l.sensor_name || l.location_name || l.name,
        }));
      case "ignore_sensor_measurement_at_start":
        return ignoreSensorTimes;
      default:
        return [];
    }
  };

  const isMulti = ["teams", "products"].includes(editingFieldKey);
  const showSelect = [
    "courier",
    "sensor",
    "teams",
    "products",
    "from_location",
    "to_location",
    "ignore_sensor_measurement_at_start",
  ].includes(editingFieldKey);

  return (
    <>
      <CustomTitle
        text="This will apply to all shipments (this can be changed for individual shipments later)"
        fontSize="14px"
        color="#5E5E5E"
        fontWeight="400"
        marginBottom="4px"
      />

      {showSelect ? (
        <Select
          style={{
            width: "100%",
            border: "none",
            backgroundColor: "#F3F3F3",
            borderRadius: 6,
            paddingLeft: 8,
            marginTop: 12,
            height: 'auto',
          }}
          mode={isMulti ? "multiple" : undefined}
          value={bulkFieldValue}
          onChange={setBulkFieldValue}
          options={renderSelectOptions()}
        />
      ) : (
        <Input
          style={{
            width: "100%",
            height: 44,
            fontSize: 12,
            backgroundColor: "#F3F3F3",
            border: "none",
            borderRadius: 6,
            paddingLeft: 8,
            marginTop: 12,
          }}
          value={bulkFieldValue}
          maxLength={editingFieldKey === "link_code" ? 10 : undefined}
          onChange={(e) => {
            const input = e.target.value;
            if (editingFieldKey === "link_code") {
              const isValid = /^[a-zA-Z0-9]*$/.test(input);
              if (isValid) setBulkFieldValue(input);
            } else {
              setBulkFieldValue(input);
            }
          }}
        />
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "8px",
          marginTop: "16px",
        }}
      >
        <CustomButton
          key="cancel"
          text="Cancel"
          onClick={() => setEditModalOpen(false)}
          bgColor="transparent"
          color="#000000"
          border="none"
          boxShadow="none"
          fontSize="14px"
          fontWeight="500"
          height="36px"
          padding="15px 15px 15px 0px"
          borderRadius="8px"
        />

        <CustomButton
          key="save"
          text="Save"
          bgColor="#000000"
          color="#FFFFFF"
          fontSize="14px"
          width="60px"
          borderRadius="8px"
          fontWeight="600"
          height="36px"
          onClick={handleSave}
        />
      </div>
    </>
  );
};

export default BulkFieldSelector;
